import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be76d4c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-gap-[12px] tw-flex" }

import Plus from "@/components/svgs/plus.vue";
import { ref, watch, onMounted } from "vue";
import { convertQuality } from "@/utils/utilities";
import { QUALITY_ASSESSMENT_TYPE } from "@/utils/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'qualityAssessment',
  props: {
  data: {
    type: String,
    required: true,
    default: "l",
  },
  type: {
    type: String,
    required: false,
    default: QUALITY_ASSESSMENT_TYPE.IMPORTANCE,
  },
  isCompleted: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const qualityData: any = ref([]);

watch(
  () => props.data,
  (newVal) => {
    qualityData.value = progressData(newVal);
  },
);

const progressData = (data) => {
  return convertQuality(data, props.isCompleted, props.type);
};
onMounted(() => {
  qualityData.value = progressData(props.data);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qualityData.value, (item, index) => {
      return (_openBlock(), _createBlock(Plus, {
        key: index,
        color: item
      }, null, 8, ["color"]))
    }), 128))
  ]))
}
}

})